import { useEffect, useState, useCallback } from 'react';
import fetch from '@frontastic/bridge/js/fetch'

export const getRequestKey = () => {
  const [requestKey, setRequestKey] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const getDatatoolsKey = useCallback(async () => {
    try {
      const response = await fetch(`/datatools/generate-key`);
      if (!response.ok) {
          throw new Error(`status code ${response.status}`)
      }
      const body = await response.json()
      return body?.temporaryKey;
    } catch (error) {
      console.error('Error from Fetch:', error);
    }
  }, []);

  useEffect(() => {
    let intervalId;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const key = await getDatatoolsKey();
        setRequestKey(key);
      } catch (error) {
        console.error('Error fetching key:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

    intervalId = setInterval(fetchData, 5 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [getDatatoolsKey]);

  return { requestKey, isLoadingKey: isLoading };
};

